<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
      class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
      <div class="w-full" @keyup.enter="submitData">
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>Fiyat Listesi Seçimi</h4>
          <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
            <div id="pager" class="mt-3">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h3 class="mx-auto my-3">{{ newPaymentMethod.name }}</h3>
        </vs-col>
      </vs-row>

    </div>
          <form data-vv-scope="form-1">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
        <vs-col vs-type="flex" vs-w="12" vs-align="center">
          <v-select v-model="selectedBranch" itemid="id" label="name" class="w-full" v-if="$isCenterBranch()"
            placeholder="Liste Seçimi.." :options="$currentUser.branch.id == 1 ? lists : []" :clearable="false">
          </v-select>
        </vs-col>
      </vs-row>
          
          </form>
          <div class="flex mt-5 px-6 pb-4">
            <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
              Vazgeç
            </vs-button>
            <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
  </template>
  
  <script>
  import {
    getBranchProductPriceLists,
    setBranchProductPriceList
  } from "@/api/BranchProductPrice.js";
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import {
      createNewPaymentMethod,
      updatePaymentMethod
    } from '@/api/PaymentMethod';
    export default {
      props: {
        isSidebarActive: {
          type: Boolean,
          required: true
        },
        data: {
          type: Object,
          default: () => {},
        }
      },
      data() {
        return {
          paymentMethodValues : [
            "Pozifif","Negatif","Nötr"
          ],
          newPaymentMethod: {},
          paymentMethods : [],
          newVariant: {},
          lists: [],
          selectedBranch: null,
          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },
        }
      },
      computed: {
        isSidebarActiveLocal: {
          get() {
            return this.isSidebarActive
          },
          set(val) {
            if (!val) {
              this.$emit('closeSidebar')
              this.$validator.reset()
              this.initValues()
            }
          }
        },
        availablePaymentMethods(){
          return this.paymentMethods.filter(x=> x.type == 'SolidRoot')
        }
      },
      methods: {
        escape(){
          if(this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
        },
        initValues: function () {
          this.newPaymentMethod = {};
        },
        submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll();
        if (checker) {
            this.newVariant.branchProductPriceListId= parseFloat(this.selectedBranch.id)
            this.newVariant.branchId = this.data.id
            setBranchProductPriceList(this.newVariant).then(res => {
            if (res.data==true && res.status == 200) {
              this.newVariant = {};
              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Fiyat Listesi Atama Başarılı"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Varyant Güncelleme Başarısız !"
              });
            }
          })
        }
      },
        mapNewUnit: async function () {
          //map
        },
      },
      components: {
        VuePerfectScrollbar
      },
      watch: {
        isSidebarActive: function (val) {
          if (!val) return;
          if (Object.entries(this.data).length === 0) {
            this.initValues();
            this.$validator.reset();
          } else {
            this.newPaymentMethod = _.cloneDeep(this.data);
          }
        }
      },
      mounted: function () {},
      created: async function () {
      this.lists = await getBranchProductPriceLists();
    }
    }
  
  </script>
  
  <style lang="scss" scoped>
    .style-chooser .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: red;
      text-transform: lowercase;
      font-variant: small-caps;
    }
  
    .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
        z-index: 52010;
      }
  
      ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;
  
        .img-upload {
          margin-top: 2rem;
  
          .con-img-upload {
            padding: 0;
          }
  
          .con-input-upload {
            width: 100%;
            margin: 0;
          }
        }
      }
    }
  
    .tabPager {
      background-color: darkgreen;
      border-radius: 50%;
    }
  
  </style>
  